import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { NutritionFacts } from "../../../Shared/components/nutritionFacts";
/**
 * ImageLoader - Attempts to load a Nutrition Label Image. If it fails, try to load recipe's nutrition info. if THAT fails, show nothing.
 * @param {*} { props: ImageLoaderProps }
 * @returns {*}
 */
export const NutritionImageLoader = (props) => {
    const { imageBaseUrl, nutritionLabelImage, nutritionMacro, labelImageCanLoad } = props;
    const ImageComponent = () => {
        // do something
        return (_jsx(Box, { children: _jsx("img", { src: `${imageBaseUrl}${nutritionLabelImage}`, style: { maxWidth: "100%" } }) }));
    };
    if (labelImageCanLoad)
        return _jsx(ImageComponent, {});
    if (!labelImageCanLoad && nutritionMacro && Object.keys(nutritionMacro).length > 0)
        return _jsx(NutritionFacts, { nutritionMacro: nutritionMacro });
    return _jsx(Box, {});
};
